import { useState, useContext } from 'react';
import './FullScreenImage.css';

const FullScreenImage = ({ image, onClose }) => {



    return (
        <div className='fullScreenImage__container' onClick={()=> onClose(false)}>
           <img className='fullScreenImage__image' src={image} alt='' />
        </div>
    )
}
export default FullScreenImage
